import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { deleteCompanyUrl } from "../../../Library/URLs";
import { toast } from "react-toastify";
import {
  IconButton,
  Divider,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  styled,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../Components/Button";
import confirm from "../../../Assets/SVG/confirm.svg";
import close from "../../../Assets/SVG/close.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    width: "552px",
    fontFamily: "Quicksand sans-serif",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  height: "auto",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  borderRadius: 2,
  boxSizing: "border-box",
  outline: "none",
};
const Model_Style = {
  position: "relative",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  border: "none",
  p: 4,
};
const Close_Btn_Style = {
  position: "absolute",
  top: ".7rem",
  right: ".7rem",
};
const Left_Btn = {
  bgcolor: "#13ABF4",
  width: 142,
  height: 35,
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  cursor: "pointer",
};
const Right_Btn = {
  bgcolor: "#636766",
  width: 142,
  height: 35,
  borderRadius: "3px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "14px",
  cursor: "pointer",
};

const Title_Style = {
  fontWeight: 500,
  fontSize: "32px",
  lineHeight: "120%",
  textAlign: "center",
  color: "#636766",
  marginTop: "1rem",
};

const Title2_Style = {
  fontWeight: 500,
  fontSize: "32px",
  lineHeight: "120%",
  textAlign: "center",
  color: "#636766",
};

const Text_Style = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "156.5%",
  textAlign: "center",
  color: "#636766",
  whiteSpace: "wrap",
};

const DeleteModal = ({ open, close }) => {
  // State management for delete request
  const [loading, setLoading] = useState(false);
  const { companyid } = useParams();

  const unique_id = uuid();
  const { User } = useSelector((state) => state.payroll);
  const navigate = useNavigate();

  // Fuction to delete company from app
  const DeleteCompany = async () => {
    setLoading(true);
    const data = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(deleteCompanyUrl, data)
      .then((res) => {
        if (res?.data?.success) {
          setLoading(false);
          close();
          navigate("/companies")
          toast.success(res.data?.data);
        } else {
          setLoading(false);
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.data?.message);
        // console.log('Get all payroll error',err.message)
      });
  };
  return (
    <BootstrapDialog
      open={open}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={close}>
        {/* <div className="Name">Proxy Employee</div> */}
      </BootstrapDialogTitle>
      <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
      <DialogContent sx={{ pb: 10 }}>
        <DialogContentText id="alert-dialog-description">
          Proceed to delete the company
        </DialogContentText>
      </DialogContent>
      <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
      <DialogActions>
        <Button Click={close} variant="outlined">
          Cancel
        </Button>
        <Button
          Click={DeleteCompany}
          variant="contained"
          autoFocus
          style={{
            backgroundColor: "#13ABF4",
          }}
        >
          {loading ? <CircularProgress color="inherit" size={20} /> : "Proceed"}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default DeleteModal;
